<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
import StocksModal from "@/components/modals/stocks.vue"
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
    props: {
        modalTitle: String,
        hideStock: {
            type: Boolean,
            default: false,
        },
        side: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        MaskedInput,
        ItemCategory,
        Unit,
        StocksModal,
    },
    data(){
        return {
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            submitted: false,
            form: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                itemCategoryId: "",
                unitCost: "",
                type: "",
                year: "",
                isProcurable: true,
                inDbm: false,
                subType: "",
                stockId: 0,
            },
            unitType: "",
            unit: "",
            itemCategory: "",
            subType: "",
            stockId: null,
        }
    },
    validations: {
        form: {
            itemName: { required },
            description: { required },
            unitId: { required },
            itemCategoryId: { required },
            unitCost: { required },
            type: { required },
            year: { required },
        },
        subType: { required },
    },
    methods: {
        putData(data){
            this.$v.$reset();
            this.form = cloneDeep(data);
            this.unit = data.unitFormName;
            this.itemCategory = data.formItemCategory;
            this.stockId = data.formStockId;
            this.subType = data.formSubType;
        },
        getUnit() {
            if(this.side){
                this.$emit('get-unit');
                return;
            }
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.unit = data.unitName;
            this.form.unitId = data.id;
        },
        getItemCategory() {
            if(this.side){
                this.$emit('get-item-category');
                return;
            }
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.itemCategory = data.name;
            this.form.itemCategoryId = data.id;
        },
        getStocks() {
            this.$bvModal.show("stocks-modal");
            this.$refs.stockRef.getData();
        },
        dropStocks(data){
            this.stockId = data.stockNumber;
            this.form.stockId = data.id;
        },
        onCreate(){
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            if (this.form.isProcurable) {
                this.$v.subType.$touch();
                if (this.$v.subType.$invalid) {
                    return;
                }
                this.form.subType = cloneDeep(this.subType);
            } else {
                this.form.subType = "";
            }
            this.form.unit = {
                id: this.form.unitId,
                unitName: this.unit,
            }
            this.form.itemCategory = {
                id: this.form.itemCategoryId,
                name: this.itemCategory
            }
            this.$emit('dropData', this.form);
        }
    }
}
</script>
<template>
    <div>
        <b-modal
            id="item-form-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="itemName">
                        Item Name
                    </label>
                    <input
                        autocomplete="off"
                        id="itemName"
                        type="text"
                        v-model="form.itemName"
                        placeholder="Enter Item Name..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.itemName.$error,
                        }"
                    />
                    <div
                        v-if="
                            submitted &&
                            $v.form.itemName.$error
                        "
                        class="invalid-feedback"
                    >
                        <span
                            v-if="
                                !$v.form.itemName.required
                            "
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description"
                        >Specifications
                    </label>
                    <textarea
                        id="description"
                        type="text"
                        v-model="form.description"
                        placeholder="Enter Specifications..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.description.$error,
                        }"
                    ></textarea>
                    <div
                        v-if="
                            submitted &&
                            $v.form.description.$error
                        "
                        class="invalid-feedback"
                    >
                        <span
                            v-if="
                                !$v.form.description
                                    .required
                            "
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="unitId">Unit </label>
                    <b-input-group>
                        <template #append>
                            <b-button
                                @click="getUnit"
                                variant="outline-info"
                                ><i
                                    class="
                                        mdi
                                        mdi-clipboard-text-search-outline
                                    "
                                ></i
                            ></b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search Unit..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.unitId.$error,
                            }"
                            v-model="unit"
                        />
                    </b-input-group>
                    <div
                        v-if="
                            submitted &&
                            $v.form.unitId.$error
                        "
                        class="invalid-feedback"
                    >
                        <span
                            v-if="!$v.form.unitId.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="itemCategoryId"
                        >Item Category
                    </label>
                    <b-input-group>
                        <template #append>
                            <b-button
                                @click="getItemCategory"
                                variant="outline-info"
                                ><i
                                    class="
                                        mdi
                                        mdi-clipboard-text-search-outline
                                    "
                                ></i
                            ></b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search Item Category..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.itemCategoryId
                                        .$error,
                            }"
                            v-model="itemCategory"
                        />
                    </b-input-group>
                    <div
                        v-if="
                            submitted &&
                            $v.form.itemCategoryId.$error
                        "
                        class="invalid-feedback"
                    >
                        <span
                            v-if="
                                !$v.form.itemCategoryId
                                    .required
                            "
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3" v-if="!hideStock">
                    <label for="itemCategoryId">Stock Number
                    </label>
                    <b-input-group>
                        <template #append>
                            <b-button
                                @click="getStocks"
                                variant="outline-info"
                                >
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search Stock Number..."
                            class="form-control"
                            v-model="stockId"
                        />
                    </b-input-group>
                </div>
                <div class="mb-3">
                    <label for="unitCost">Unit Cost </label>
                    <masked-input
                        autocomplete="off"
                        id="unitCost"
                        type="text"
                        v-model="form.unitCost"
                        class="form-control"
                        :class="{
                            'is-invalid':
                                $v.form.unitCost.$error,
                        }"
                        :mask="currencyMask"
                    ></masked-input>
                    <div
                        v-if="
                            submitted &&
                            $v.form.unitCost.$error
                        "
                        class="invalid-feedback"
                    >
                        <span
                            v-if="
                                !$v.form.unitCost.required
                            "
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="type">Type </label>
                        <b-form-select
                            id="type"
                            v-model="form.type"
                            class="
                                form-select
                                custom-select
                            "
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.type.$error,
                            }"
                        >
                            <option></option>
                            <option>CSE</option>
                            <option>NON-CSE</option>
                        </b-form-select>
                        <div
                            v-if="
                                submitted &&
                                $v.form.type.$error
                            "
                            class="invalid-feedback"
                        >
                            <span
                                v-if="
                                    !$v.form.type.required
                                "
                                >This value is
                                required.</span
                            >
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="year">Year </label>
                        <input
                            autocomplete="off"
                            id="year"
                            type="text"
                            v-model="form.year"
                            placeholder="Enter Year..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.form.year.$error,
                            }"
                        />
                        <div
                            v-if="
                                submitted &&
                                $v.form.year.$error
                            "
                            class="invalid-feedback"
                        >
                            <span
                                v-if="
                                    !$v.form.year.required
                                "
                                >This value is
                                required.</span
                            >
                        </div>
                    </div>
                    <!-- <div class="d-flex mt-2 mb-3">
                        <div class="me-2">
                            <input
                                autocomplete="off"
                                class="form-check-input"
                                type="checkbox"
                                id="isProcurable"
                                v-model="form.isProcurable"
                            />&nbsp;&nbsp;
                            <label
                                class="form-check-label"
                                for="isProcurable"
                                >Is Procurable?</label
                            >
                        </div>
                    </div> -->
                    <div v-if="form.isProcurable">
                        <label for="subType"
                            >Sub Type
                        </label>
                        <select
                            class="form-select"
                            id="subType"
                            v-model="subType"
                            placeholder="Select Sub Type..."
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.subType.$error,
                            }"
                        >
                            <option></option>
                            <option value="Goods">Goods</option>
                            <option value="Services">Goods (General Support Services)</option>
                            <option value="Consultancy">Consulting Services</option>
                            <option value="Infrastructure">Infrastructure Projects</option>
                        </select>
                        <div
                            v-if="
                                submitted &&
                                $v.subType.$error
                            "
                            class="invalid-feedback"
                        >
                            <span
                                v-if="!$v.subType.required"
                                >This value is
                                required.</span
                            >
                        </div>
                    </div>
                    <div class="mt-2">
                        <input
                            autocomplete="off"
                            class="form-check-input"
                            type="checkbox"
                            id="inDbm"
                            v-model="form.inDbm"
                        />&nbsp;&nbsp;
                        <label
                            class="form-check-label"
                            for="inDbm"
                            >In DBM?</label
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('item-form-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <template v-if="!side">
            <unit ref="unit" @dropData="dropUnit($event)"></unit>
            <item-category @dropData="dropItemCat($event)"></item-category>
        </template>
        <stocks-modal ref="stockRef" @dropData="dropStocks($event)"></stocks-modal>
    </div>
</template>